import Flipper from "./Flipper";
import Flipped from "./Flipped";
import ExitContainer from "./ExitContainer";

// for umd build
export default {
  Flipper: Flipper,
  Flipped: Flipped,
  ExitContainer: ExitContainer
};

export { default as Flipper } from "./Flipper";
export { default as Flipped } from "./Flipped";
export { default as ExitContainer } from "./ExitContainer";